import { ICON_NEUTRAL_COLOR } from "@src/appV2/lib/Theme/constants";
import { ShieldIcon } from "@src/appV2/redesign/EmergencyCredits/components/ShieldIcon";
import { Text } from "@src/appV2/redesign/system/ui-components";

export function IntroStep() {
  return (
    <>
      <ShieldIcon variant="outlined" sx={{ width: 64, height: 64, color: ICON_NEUTRAL_COLOR }} />
      <Text variant="h3" sx={{ fontWeight: 400, whiteSpace: "pre-line" }}>
        Introducing{"\n"}Emergency Credits
      </Text>
      <Text sx={{ fontWeight: 400 }} color={(theme) => theme.palette.text.secondary}>
        When the unexpected happens, Emergency Credits protect your Clipboard Score from the
        occasional same-day cancellation or late arrival.
      </Text>
    </>
  );
}
